import React from 'react';
import { Alert, List } from "@curves/ui-base";
import { isEmpty } from '@util/utils';
import TodoItem from './TodoItem';
import PropTypes from 'prop-types';

const TodoList = ({ todos, onToggleCompleted, onDeleteItem }) => {
    return (
        <>
            {!isEmpty(todos) ? (
                <List>
                    {todos.map((todo) => (
                        <TodoItem key={todo.taskID} todo={todo} onToggleCompleted={onToggleCompleted} onDeleteItem={onDeleteItem} />
                    ))}
                </List>
            ) : (
                <Alert variant="standard" severity="info" color="info">
                    尚無資料
                </Alert>
            )}
        </>
    );
};

TodoList.propTypes = {
    todos: PropTypes.array.isRequired,
};

export default TodoList;
